import $ from 'jquery';

const WorkOrderCategories = {
  init() {
    this.$userSelect = $('#work_order_user_id');
    this.$categorySelect = $('#work_order_professional_category_id');

    if (!this.$userSelect.length || !this.$categorySelect.length) {
      return false;
    }

    // Store the initially selected professional category ID
    this.initiallySelectedCategoryId = this.$categorySelect.data('selected');

    this.bindEvents();

    // Initialize if user is already selected
    if (this.$userSelect.val()) {
      this.loadProfessionalCategories(this.$userSelect.val());
    }

    return true;
  },

  bindEvents() {
    // Handle both regular change and Select2 events
    this.$userSelect.on('change select2:select', (e) => {

      let userId;
      if (e.type === 'select2:select') {
        userId = e.params.data.id;
      } else {
        userId = $(e.target).val();
      }

      this.loadProfessionalCategories(userId);
    });
  },

  loadProfessionalCategories(userId) {
    if (!userId) {
      this.resetCategorySelect('Seleccionar usuari primer');
      return;
    }

    this.showLoadingState();

    // Pass the initially selected category ID to the server
    $.ajax({
      url: `/users/${userId}/professional_categories.json`,
      type: 'GET',
      dataType: 'json',
      data: {
        include_selected: this.initiallySelectedCategoryId
      },
      success: (categories) => this.handleCategoriesLoaded(categories),
      error: () => this.handleCategoriesError()
    });
  },

  showLoadingState() {
    this.$categorySelect.empty().prop('disabled', true);
    this.$categorySelect.append($('<option>', { value: '', text: 'Carregant categories...' }));

    // Update Select2 if present
    if (this.$categorySelect.hasClass('selectized')) {
      this.$categorySelect.trigger('change.select2');
    }
  },

  handleCategoriesLoaded(categories) {
    this.$categorySelect.empty();
    this.$categorySelect.append($('<option>', { value: '', text: 'Seleccionar opció' }));

    if (categories.length > 0) {
      $.each(categories, (index, category) => {
        const $option = $('<option>', {
          value: category.id,
          text: category.name
        });

        // Check if this category should be selected
        if (category.id === parseInt(this.initiallySelectedCategoryId)) {
          $option.prop('selected', true);
        }

        this.$categorySelect.append($option);
      });

      this.$categorySelect.prop('disabled', false);
    } else {
      // Even if no active categories, check if we should include the initially selected one
      if (this.initiallySelectedCategoryId) {
        this.loadInitiallySelectedCategory();
      } else {
        this.resetCategorySelect('Aquest usuari no té categories');
      }
    }

    // Update Select2 if present
    if (this.$categorySelect.hasClass('selectized')) {
      this.$categorySelect.trigger('change.select2');
    }
  },

  loadInitiallySelectedCategory() {
    // If the user has no active categories but there's a previously selected category,
    // we need to fetch that specific category to display it
    if (!this.initiallySelectedCategoryId) return;

    $.ajax({
      url: `/professional_categories/${this.initiallySelectedCategoryId}.json`,
      type: 'GET',
      dataType: 'json',
      success: (category) => {
        if (category) {
          this.$categorySelect.empty();
          this.$categorySelect.append($('<option>', { value: '', text: 'Seleccionar opció' }));

          const $option = $('<option>', {
            value: category.id,
            text: category.name + ' (eliminada)',
            selected: true
          });

          this.$categorySelect.append($option);
          this.$categorySelect.prop('disabled', false);
        } else {
          this.resetCategorySelect('Aquest usuari no té categories');
        }
      },
      error: () => {
        this.resetCategorySelect('Aquest usuari no té categories');
      }
    });
  },

  handleCategoriesError() {
    this.resetCategorySelect('Error carregant categories');
  },

  resetCategorySelect(message) {
    this.$categorySelect.empty().prop('disabled', true);
    this.$categorySelect.append($('<option>', { value: '', text: message }));

    // Update Select2 if present
    if (this.$categorySelect.hasClass('selectized')) {
      this.$categorySelect.trigger('change.select2');
    }
  }
};

// Initialize when DOM is ready
$(document).ready(function() {
  WorkOrderCategories.init();
});

export default WorkOrderCategories;
